import { compact, join } from '@quromedical/utils';
import type { Encounter } from 'fhir/r4';

import { getReferenceId } from '../id';

/**
 * Filter encounters by location
 *
 * @param encounters - The encounters to filter
 * @param locationIds - The location ids to filter by
 * @returns The encounters that match the location ids
 */
export const fillerEncountersByLocations = <T extends Encounter>(
  encounters: T[],
  locationIds: string[],
): T[] => {
  const locations = new Set(locationIds);

  return encounters.filter((encounter) => {
    const encounterLocations = encounter.location || [];

    return encounterLocations.some((location) => {
      const id = getReferenceId(location.location) || '';

      return locations.has(id);
    });
  });
};

/**
 * Get the subjects from a list of encounters
 *
 * @param encounters - The encounters to get the subjects from
 * @returns The subjects from the encounters
 */
export const getSubjectsFromEncounters = (encounters: Encounter[]) => {
  return encounters.reduce((memo: string[], encounter) => {
    const id = getReferenceId(encounter.subject);

    if (id) {
      memo.push(id);
    }

    return memo;
  }, []);
};

type AdmissionStatus = Encounter['status'];
/**
 * Returns a FHIR-compatible query string for multiple admission statuses.
 * @param statuses An array of admission status strings
 */
export const getStatusQueryString = (statuses?: AdmissionStatus[]): string => {
  const filtered = compact(statuses);

  return join(filtered, ',');
};
